import React from 'react';

import { Button, PlusCircleIcon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

import usePayloadConditions from './usePayloadConditions';

const MAX_PAYLOAD_CONDITIONS = 3;
const MAX_CONDITIONS_MESSAGE = `Maximum of ${MAX_PAYLOAD_CONDITIONS} conditions`;

export default function EventDebuggerAddPayloadFilterButton() {
  const { payloadConditions, addCondition } = usePayloadConditions();
  const atMaxConditions = payloadConditions.length >= MAX_PAYLOAD_CONDITIONS;

  return (
    <WithTooltip show={atMaxConditions} title={MAX_CONDITIONS_MESSAGE}>
      <Button
        variant="text"
        color="secondary"
        size="small"
        startIcon={<PlusCircleIcon />}
        onClick={addCondition}
        disabled={atMaxConditions}
        data-test-id="addPayloadConditionButton"
      >
        Add Condition
      </Button>
    </WithTooltip>
  );
}
